import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M16.666 3.333H3.333c-.917 0-1.658.75-1.658 1.667l-.008 10c0 .917.75 1.667 1.666 1.667h13.333c.917 0 1.667-.75 1.667-1.667V5c0-.917-.75-1.667-1.667-1.667zm0 2.942c0 .244-.125.47-.332.6l-5.804 3.627a1 1 0 01-1.06 0L3.665 6.874a.707.707 0 01.75-1.198l5.055 3.16a1 1 0 001.06 0l5.055-3.16a.707.707 0 011.081.599z",
    fill: "#EE4D2D"
  }));
}
export default SvgComponent;